'use client';

import { useTranslations, useLocale } from 'next-intl';
import Image from 'next/image';
import { Button } from '@/components/ui/button';

const offlineIcon =
  'data:image/png;base64,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';

export default function NotFound() {
  const tErrors = useTranslations('common.errors');
  const tCommon = useTranslations('common');
  const locale = useLocale();

  const handleBackHome = () => {
    // locale 形如 en-US / pt-BR，取前缀做路径
    const simplified = locale.split('-')[0] || 'en';
    window.location.href = `/${simplified}`;
  };

  return (
    <div className="flex items-center justify-center min-h-screen flex-col bg-dark">
      <Image
        className="w-[60px] h-[60px] mb-[24px]"
        src={offlineIcon}
        alt="404"
        width={60}
        height={60}
        priority
        unoptimized
      />

      <h1
        style={{
          fontSize: '40px',
          fontWeight: 700,
          marginBottom: '12px',
        }}
      >
        404
      </h1>

      <p
        className="mb-[28px] text-center px-5"
        style={{
          fontFamily: 'Montserrat',
          fontWeight: 500,
          fontSize: '12px',
          color: 'var(--text-tertiary)',
          lineHeight: '15px',
        }}
      >
        {tErrors('notFoundDescr')}
      </p>

      <Button
        className="w-[175px]"
        variant="primary"
        onClick={handleBackHome}
      >
        {tCommon('home')}
      </Button>
    </div>
  );
}